import { render, staticRenderFns } from "./diaoview.vue?vue&type=template&id=1d71a203&scoped=true"
import script from "./diaoview.vue?vue&type=script&lang=js"
export * from "./diaoview.vue?vue&type=script&lang=js"
import style0 from "./diaoview.vue?vue&type=style&index=0&id=1d71a203&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d71a203",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d71a203')) {
      api.createRecord('1d71a203', component.options)
    } else {
      api.reload('1d71a203', component.options)
    }
    module.hot.accept("./diaoview.vue?vue&type=template&id=1d71a203&scoped=true", function () {
      api.rerender('1d71a203', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/sbgl/diaoview.vue"
export default component.exports